import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config.json";
import PageSizeOptions from "../PageSizeOptions";
import AddCandidate from "./AddCandidate";
import Moment from "react-moment";
import ActiveDeactiveHistory from "../SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { paginate, calculateIndex } from "../../utlis/paginate";
import ReminderAlertMessage from "../ReminderAlertMessage";
import ViewCandidate from "./ViewCandidate";
import Pagination from "../../comman/pagination";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import AddEditDuration from "./AddEditDuration";
import {
  loadCandidates, getAllCandidates,
  getFilterAllCandidates,
  SendReminder, getReminderStatus,
  loadAllCandidatesByFilter,
  candidateBprmFormReceived,
  getCandidateBprmForm,
  loadCandidateBprmForm,
  selectedCandidateObjReceiveClear,
  getCandidateApps,
  filterAllCandidatesStatus,
  getFilterCandidatesStatus,
  receivedCandidateById,
  getCandidateNameList,
  loadCandidateNameList,
  candidateAppsReceived
} from "../../app/store/candidate";
import { getCurrentUser } from "../../app/store/auth";
import { getFieldData, getFormatedNumber } from "../../services/appService";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../services/appAlerts";
import AddEditRates from "./AddEditRates";
import Document from "../PortalForms/Document";
import {
  getFilterAllSubcontractors, getFilterAllSubcontractors2, getSubcontractorBprmForm, getSubsCurrentWfTask,
  loadSubcontractorBprmForm, loadSubcontractorWfTask, receivedSubcontractorById, subsCurrentWfTaskReceived
} from "../../app/store/subcontractor";
import {
  getFilterAllRecruiters, getFilterAllRecruiters2, getRecCurrentWfTask, getRecruiterBprmForm,
  loadRecruiterBprmForm, loadRecruiterWfTask, recCurrentWfTaskReceived
} from "../../app/store/recruiter";
import WorkflowElement from "../../app/components/WorkflowElement";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import { formLibraryReceived } from "../../app/store/forms";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived } from "../../app/store/documents";
import RateEncryptDecrypt from "../../services/RateEncryptDecrypt";
import { purchaseOrdersReceived } from "../../app/store/purchaseOrder";
import { repositoryDocumentsReceived } from "../../app/store/ddrmsDocument";
import {
  getAgenciesPartners, getRecruiterPartners, getSubcontractorPartners, loadAgencies,
  loadRecruiterPartners, loadSubcontractorPartners
} from "../../app/store/partner";
import _, { set } from "lodash";

export default function ListCondidate(props) {



  const currentUser = getCurrentUser();

  const [applicantType, setApplicantType] = useState("candidate");
  const [actionType, setActionType] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [applicantCount, setApplicantCount] = useState(0);
  const [allTypesCount, setAllTypesCount] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);
  const [viewShowHide, setViewShowHide] = useState(false);
  const [durationShowHide, setDurationShowHide] = useState(false);
  const [docShowHide, setDocShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState("");
  const [viewType, setViewType] = useState("");
  const [editDurType, setEditDurType] = useState("");

  const [canId, setCanId] = useState("");
  const [canName, setCanName] = useState("");
  const [canEmail, setCanEmail] = useState("");
  const [canEntity, setCanEntity] = useState("");
  const [canSubcontractor, setCanSubcontractor] = useState("");
  const [canRecruiter, setCanRecruiter] = useState("");
  const [canAgency, setCanAgency] = useState("");

  const [dataType, setDataType] = useState("");
  const [selectedCandidateId, setSelectedCandidateId] = useState(0);
  const [selectedKey, setSelectedKey] = useState(-1);
  const [infoApp, setInfoApp] = useState("");
  const [wfflowtask, setWfflowtask] = useState("");
  const [infoItem, setInfoItem] = useState("");
  const [selectedInfo, setSelectedInfo] = useState("");
  const [SelectedFormKey, setSelectedFormKey] = useState(-1);
  const [selectedTabKey, setSelectedTabKey] = useState("home");
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [viewFormData, setviewFormData] = useState({});
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfId, setWfId] = useState(0);

  const [entityType, setEntityType] = useState(null);
  const [w2Type, setW2type] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);
  const [achType, setAchType] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [purchaseShowHide, setPurchaseShowHide] = useState(false);
  const [poOrderType, setPoOrderType] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [contractDocType, setContractDocType] = useState("");
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [partnerAppData, setPartnerAppData] = useState(null);

  const [filterSubcontractorList, setFilterSubcontractorList] = useState([]);
  const [filterRecruiterList, setFilterRecruiterList] = useState([]);
  const [filterAgencyList, setFilterAgencyList] = useState([]);
  const [filterCandidateList,setFilterCandidateList]=useState([]);
  const [filterShowHide,setFilterShowHide]=useState(false);


  const allCandidates = useSelector(getAllCandidates);
  const filterAllCandidates = useSelector(getFilterAllCandidates);
  const remiderStatus = useSelector(getReminderStatus);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
  const filterAllSubcontractors2 = useSelector(getFilterAllSubcontractors2);
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const filterAllRecruiters2 = useSelector(getFilterAllRecruiters2);
  const candidateAppsSelector = useSelector(getCandidateApps);

  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const getfilterStatus = useSelector(getFilterCandidatesStatus)

  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);

  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);
  const recruiterPartnersSelector = useSelector(getRecruiterPartners);
  const agenciesPartnersSelector = useSelector(getAgenciesPartners);
  const candidateNameListSelector = useSelector(getCandidateNameList);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const candidateEntity = [
    { id: 1, name: "C2C Basis" },
    { id: 2, name: "1099 Basis" },
    { id: 3, name: "W2 Basis" },
  ];

  const param = useParams();
  let type = param?.type;
  let candidateType = "";

  useEffect(() => {
    const filterTypes = type.split('-')
    if (filterTypes.length > 1) {
      candidateType = filterTypes[1];
      type = filterTypes[0];
    }

    let route = [
      { name: "Onboarding and Contracts", url: "" }
    ];
    let pgTitle = "Candidates";
    if (type === "partner") {
      route = [
        { name: "System Administration", url: "" },
        { name: "Manage Entities", url: "" },
      ];
    }

    if (type === "timelog" || type === "invoice") {
      route = [{ name: "Invoices", url: "" }];
      if (type === "timelog") pgTitle = "Time Log Management";
      if (type === "invoice") pgTitle = "Invoices and Payments";
    }
    if (candidateType === "c2c")
      setCanEntity("C2C Basis");

    if (candidateType === "w2")
      setCanEntity("W2 Basis");

    if (candidateType === "1099")
      setCanEntity("1099 Basis");

    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle(pgTitle));
  }, [type])

  useEffect(() => {
    // dispatch(loadSubcontractorPartners("Sub-Contractors"));
    // dispatch(loadRecruiterPartners("Recruiter"));
    // dispatch(loadAgencies())
  }, []);

  useEffect(() => {
    setFilterSubcontractorList(subcontractorPartnersSelector);
  }, [subcontractorPartnersSelector])

  useEffect(() => {
    setFilterRecruiterList(recruiterPartnersSelector);
  }, [recruiterPartnersSelector])

  useEffect(()=>{
    setFilterCandidateList(candidateNameListSelector)
  },[candidateNameListSelector])

  useEffect(() => {
    const list = _.unionBy(agenciesPartnersSelector, "title")?.filter(x => x.title && x.title !== "");
    setFilterAgencyList(list);
  }, [agenciesPartnersSelector])

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    setSelectedTabKey("home");
    setSelectedKey(-1);
    setSelectedCandidateId(0);
    setSelectedObj("")
  }, [type])

  useEffect(() => {
    if (getfilterStatus === "") {
      handleLoadFilterCandidates(pageSize, 1);
    } else if (getfilterStatus.dataType === "filter") {
      setCanId(getfilterStatus.id);
      setCanName(getfilterStatus.name);
      setCanEmail(getfilterStatus.email);
      setCanEntity(getfilterStatus.entity);

    }
  }, [candidateType]);

  useEffect(() => {
    if (selectedTabKey === "home") {
      // handleLoadFilterCandidates(pageSize, 1);
      setSelectedObj("")
      setSelectedCandidateId(0)
      dispatch(selectedCandidateObjReceiveClear())
    }
  }, [selectedTabKey])

  const handleLoadFilterCandidates = (pages, index) => {
    if (candidateType === "c2c")
      dispatch(loadCandidates(pages, index, applicantType + "-C2C Basis"));

    if (candidateType === "w2")
      dispatch(loadCandidates(pages, index, applicantType + "-W2 Basis"));

    if (candidateType === "1099")
      dispatch(loadCandidates(pages, index, applicantType + "-1099 Basis"));

    if (candidateType === "")
      dispatch(loadCandidates(pages, index, applicantType));
  }

  const handleAddEditCandidate = () => {
    if (dataType === "filter")
      handleFilter();
    else
      handleLoadFilterCandidates(pageSize, currentPage);
  }

  useEffect(() => {
    console.log(allCandidates);
    if (allCandidates.length > 0) {
      if (allCandidates.length > 0)
        setRowsCount(allCandidates[0].totalApplicants);

      setCandidates(allCandidates);
      handleCloseDocumentView();
    }
  }, [allCandidates]);

  useEffect(() => {
    setPageSize(5);
    setCurrentPage(1);
    getPagedData(filterAllCandidates, 1, 5);
  }, [filterAllCandidates]);

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllCandidates, currentPage, pageSize);
      else
        handleLoadFilterCandidates(pageSize, currentPage);
    }
  }, [remiderStatus]);

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (dataType === "filter")
      getPagedData(filterAllCandidates, page, pageSize)
    else
      handleLoadFilterCandidates(pageSize, page);
  };


  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (dataType === "filter")
      getPagedData(filterAllCandidates, currentPage, currentTarget.value);
    else
      handleLoadFilterCandidates(currentTarget.value, currentPage);
  };

  const handleModalShowHide = (obj, type) => {
    if (obj === "save") {
      if (dataType === "filter")
        handleFilter();
      else
        dispatch(loadCandidates(pageSize, currentPage, applicantType));

    } else {
      setShowHide(!showHide);
      setSelectedObj(obj);
      setActionType(type);
    }
  };

  const handleViewShowHide = (obj, view, key) => {
    setSelectedObj(obj);
    setEditDurType("")
    setSelectedFormKey(-1)
    if (viewType === view) {
      setViewShowHide(false);
      setSelectedKey(-1);
      setViewType("");
      setEditDurType("none");
    }
    else {
      setViewShowHide(true);
      setViewType(view);
      setSelectedKey(key)
    }

  };

  const handleViewcandidate = (item) => {

    // state: {
    //   item: item,
    //   currentUser: currentUser,
    //   type: type,
    //   selectedApp: app.applicationId,
    //   module: "Candidate",
    //   appType: "Candidate",
    // }
    // dispatch(loadAppSummary(state.task.ciid));
    // const appSummarySelector = useSelector(getAppSummary);
  }

  const handleGoBackCan = () => {
    setSelectedTabKey("home")
  }

  const handleLogShowHide = (item, actionType) => {

    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);

      if (dataType === "filter")
        handleFilter();
      else
        dispatch(loadCandidates(pageSize, currentPage, applicantType));

    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);

    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalApplicants);

    setCandidates(items);
    handleCloseDocumentView();
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide)
  };

  const handleCandidateFilter = () => {
    handleCloseDocumentView();
    handleCloseViewForm();
    closeACHInsu();
    setSelectedFormKey(-1);
    setSelectedObj("");
    setViewShowHide(false);
    handleFilter();
  }

  const handleFilter = async () => {
    setDataType("filter");
    const frmBody = new FormData();
    frmBody.append("id", canId);
    frmBody.append("name", canName);
    frmBody.append("email", canEmail);
    frmBody.append("type", applicantType);
    frmBody.append("entity", canEntity);
    frmBody.append("subId", canSubcontractor);
    frmBody.append("recId", canRecruiter);
    frmBody.append("agency", canAgency);
    frmBody.append("filterType", "search");
    dispatch(loadAllCandidatesByFilter(frmBody));
    dispatch(filterAllCandidatesStatus({
      "id": canId,
      "name": canName,
      "email": canEmail,
      "dataType": "filter",
      "entity": canEntity,
    }));
  };

  const handleFilterCancel = async (type) => {

    if (type === "close" && filterShowHide)
      setFilterShowHide(false);

    setDataType("");
    setCanId("");
    setCanName("");
    setCanEmail("");
    setCanEntity("");
    setCanSubcontractor("");
    setCanRecruiter("");
    setCanAgency("");
    setCurrentPage(1);
    setPageSize(5);
    dispatch(loadCandidates(5, 1, applicantType))
    dispatch(filterAllCandidatesStatus(""));
    setViewFormType("");
    setSelectedKey(-1);
    setSelectedFormKey(-1);
    setEntityType("");
    setFetchedDataType("")
    setW2type(null);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEditDurType("");
    closeACHInsu()
  };

  const handleDurationAndRateShowHide = (obj, type, key) => {
    setSelectedFormKey(-1);
    setFetchedDataType("ViewForm");
    setViewFormType("");
    setViewType("");
    if (fetchedDataType !== "ViewForm") {
      setEditDurType("");
      setSelectedKey(-1)
    }
    // if (type === "save") {
    //   if (dataType === "filter") handleFilter();
    //   else dispatch(loadCandidates(pageSize, currentPage, applicantType))
    // }
    setSelectedObj(obj);
    setViewShowHide(false);
    if (editDurType === type) {
      setEditDurType("");
      setSelectedKey(-1)
    }
    else {
      setEditDurType(type);
      setSelectedKey(key)
    }

    // handleViewShowHide(obj, type, key)
  };

  const checkTerminateDuration = (item, key) => {
    if (item.duration === null) return "";
    if (item.duration?.terminateStatus)
      return (
        <>
          <br />
          <button
            className="btn btn-sm mt-2 btn-outline-default"
            onClick={() => handleDurationAndRateShowHide(item, "terminated", key)}
          >
            Terminated
          </button>
        </>
      );
    const newStartDate = new Date();
    const newEndDate = new Date(item.duration?.endDate);
    const one_day = 1000 * 60 * 60 * 24;
    let result;
    result = Math.ceil(
      (newEndDate.getTime() - newStartDate.getTime()) / one_day
    );
    if (result < 45 && result > 0)
      return (
        <>
          <br />
          <button className="btn btn-sm mt-2 invalid text-white">
            Expiring Soon...
          </button>
        </>
      );

    if (result < 0)
      return (
        <>
          <br />
          <button className="btn btn-sm mt-2 invalid text-white">
            Expired
          </button>
        </>
      );
    return "";
  };

  const handleViewApplication = (item, app) => {
    // navigate("/CustomerApps", {
    //   state: {
    //     item: item,
    //     currentUser: currentUser,
    //     type: type,
    //     selectedApp: app.applicationId,
    //     module: "Candidate",
    //     appType: "Candidate",
    //   }
    // })
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "Candidate",
        module: "Candidate",
      }
    })
  }

  const getLastWorkflowTask = (workflowTasks) => {
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handleViewCandidateDetails = (item, type) => {
    navigate("/CandidateDetails", { state: { item, type } });
  }

  const handleResetSelection = () => {
    setSelectedCandidateId(0);
    setSelectedObj(null);
  }

  const handleSelectCandidate = (item) => {
    setSelectedCandidateId(item.performerid)
    setSelectedObj(item);
  }

  const handleViewcandidateForm = (type, key, item) => {
    console.log("handleViewcandidateForm")
    if (viewFormType === type) return;

    setSelectedKey(-1);
    setViewFormType(type);
    setFetchedDataType("Form")
    setSelectedFormKey(key);
    setCandidateObj(item);

    if (type === "Candidate") {
      const entType = getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity");
      const w9type = getFieldData(item.performerData, "candidateonboardingform", "w9_Type");
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
    } else if (type === "Subcontractor") {
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
      dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid));
    } else if (type === "Recruiter") {
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
      dispatch(loadRecruiterWfTask(item?.recruiter?.parentid));
    }
  }

  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setWfTask({ formId: config.formIds.subcontractor, ciid: subsCurrentWfTaskSelector.ciid });
      setPartnerAppData(subsCurrentWfTaskSelector.appData);
    }
  }, [subsCurrentWfTaskSelector])

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setWfTask({ formId: config.formIds.recruiter, ciid: recCurrentWfTaskSelector.ciid });
      setPartnerAppData(recCurrentWfTaskSelector.appData);
    }
  }, [recCurrentWfTaskSelector])

  const handleCloseViewForm = () => {
    setViewFormType("");
    setFetchedDataType("");
    setSelectedFormKey(-1);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEntityType("");
    setW2type(null);
    dispatch(candidateBprmFormReceived(null));
    setPartnerCurrentWfTask(null);
  }

  const setCandidateType = (entType) => {
    let appCiid = 0;
    if (candidateObj?.applications?.length > 0) {
      const allWfTasks = candidateObj?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }
    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis))
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis))
    }
  }

  useEffect(() => {
    if (candidateObj) {
      if (candidateObj.applications?.length > 0) {
        setUpdatedStateData(candidateObj.applications[0].applicationData);
      }
      else {
        setUpdatedStateData(candidateObj.performerData)
      }
    } else {
      setUpdatedStateData(null);
    }
  }, [candidateObj])

  useEffect(() => {
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector])

  const handlePermissionShowHide2 = () => {
    dispatch(loadCandidates(pageSize, currentPage, applicantType))
    setSelectedTabKey("home")
  };

  const setCanEntityFunc = (data) => {
    setCanEntity(data.value)
    setDataType("")
  }

  const handleDocumentViewShowHide = (type, key, app, item) => {
    if (editDurType === type) return;
    closeACHInsu()
    setSelectedFormKey(-1)
    setSelectedKey(key);
    setEditDurType(type);
    setViewShowHide(false);
    setSelectedApp(app);
    setFetchedDataType("Document");
    setCandidateObj(item);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    // if (type === "Candidate" || type === "agency" || type === "msp") {
    //   const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    //   setSelectedCurrentTask(tsk);
    // }
    // else {
    //   setSelectedCurrentTask(null);
    // }
  };

  const handleCloseDocumentView = () => {
    setFetchedDataType("");
    setSelectedKey(-1);
    setSelectedCurrentTask(null);
    setSelectedApp(null);
    setEditDurType("");
    setCandidateObj(null);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(purchaseOrdersReceived([]));
    dispatch(repositoryDocumentsReceived([]));
    dispatch(candidateAppsReceived([]))
  }

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const latestApp = candidateAppsSelector[0];
      setInfoApp(latestApp);
      setWfflowtask(getLastWorkflowTask(latestApp?.workflowTasks))
    }
  }, [candidateAppsSelector]);

  const closeACHInsu = () => {
    setSelectedInfo("");
    setSelectedKey(-1);
    setAchType("");
    setInsuranceType("");
  }

  const handleACHShowHide = (mod, type, item, key, app) => {
    if (achType === type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedCandidateById([]));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType(type);
    setInsuranceType("");
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const handleInsuranceShowHide = (mod, type, item, key, app) => {
    if (insuranceType == type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedCandidateById([]));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType("");
    setInsuranceType(type);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const handleNextTask = () => {
    console.log("")
  }

  const getAdminMspFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "candidateonboardingform",
      "Msp_AdminFee"
    );

    // const feeDo = getFieldData(
    //   item.performerData,
    //   "candidateonboardingform",
    //   "Msp_TechFee"
    // )

    let mspData = <div> {feePer !== "" && feePer !== "0" && <> Admin Fee : <b>{feePer}%</b></>} </div>;
    return mspData;
  }

  const getAdminAgencyFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee"
    );

    const feeDo = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee_Amount"
    )

    if (feePer !== "" && feePer !== "0") {
      return <>State Admin Fee : <RateEncryptDecrypt rateData={feePer} startSymbol="" endSymbol="%" /></>
    }
    else if (feeDo !== "" && feeDo !== "0") {
      return <>State Admin Fee : <RateEncryptDecrypt rateData={feeDo} /></>
    }

    return "";
  }

  const handlePurchaseShowHide = (item, type, poType) => {
    setPurchaseShowHide(!purchaseShowHide);
    setCandidateObj(item);
    setPoOrderType(type);
    setSelectedItem({ partnerType: poType })
    if (item?.applications?.length > 0) {
      const tsk = item.applications[0].workflowTasks[item.applications[0].workflowTasks.length - 1];
      setSelectedCurrentTask(tsk);
    }

  };

  const handleSignUnsignPo = (unSignPo) => {
    //setPoCount(unSignPo);
  }

  const handleRefreshPoOrders = () => {
    // if (item?.partnerId)
    //   dispatch(loadPartnerPerformers(item.partnerId));
  }

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    if (!filterShowHide) {
      if (subcontractorPartnersSelector.length === 0)
        dispatch(loadSubcontractorPartners("Sub-Contractors"));
      if (recruiterPartnersSelector.length === 0)
        dispatch(loadRecruiterPartners("Recruiter"));
      if (agenciesPartnersSelector.length === 0)
        dispatch(loadAgencies())
      if (candidateNameListSelector.length === 0) {
        let pmId = 0;
        if (canEntity === "C2C Basis") pmId = 67;
        if (canEntity === "1099 Basis") pmId = 70;
        if (canEntity === "W2 Basis") pmId = 69;
        dispatch(loadCandidateNameList(pmId));
      }
        
    }
  }

  return (
    <React.Fragment>
      <div className="col-md-12">
        <div className="card mb-4 shadow-none">
          <div className="card-header border-0 p-2">
            <div className="row">
              <div className="col-md-4">
                <PageSizeOptions
                  pageSize={pageSize}
                  onChange={handlePageSizeChanged}
                ></PageSizeOptions>
              </div>
              <div className="col-md-4 text-center">
                <div className="mb-0">
                  {allTypesCount.map((item, key) => (
                    <React.Fragment>
                      {key > 0 && ", "}{item.name} :{" "}
                      <span className="font-weight-bolder">{item.count}</span>
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div className="col-md-4 text-right">
                <button
                  className="btn btn-sm btn-outline-default btn-min-width"
                  //data-toggle="collapse"
                  //data-target="#collapseExample"
                  onClick={handleSearchShowHide}
                >
                  <i className="fa fa-search" aria-hidden="true"></i> Search
                </button>
              </div>
              {filterShowHide &&
                <div className="col-md-12">
                  <div className="p-2 bg-secondary border mt-2" id="collapseExample">
                    <div className="row">
                      <div className="col-md-5">
                         <div className="form-group">
                          <label
                            htmlFor="canName"
                            className="form-control-label"
                          >
                            Name
                          </label>
                        <select
                          name="canId"
                          id="canId"
                          className="form-control"
                          onChange={({ currentTarget }) => setCanId(currentTarget.value)}
                          value={canId}
                        >
                          <option value="0">Select Candidate</option>
                          {filterCandidateList.map((y) => (
                            <option value={y.maxloans}>
                              {y.performername} - {y.maxloans}
                            </option>
                          ))}
                        </select>
                         </div>
                      </div>
                      {/* <div className="col-md-1">
                        <div className="form-group">
                          <label
                            htmlFor="canId"
                            className="form-control-label"
                          >
                            IPCS ID
                          </label>
                          <input
                            type="text"
                            name="canId"
                            id="canId"
                            className="form-control"
                            placeholder="ID"
                            onChange={({ currentTarget }) => setCanId(currentTarget.value)}
                            value={canId}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label
                            htmlFor="canName"
                            className="form-control-label"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            name="canName"
                            id="canName"
                            className="form-control"
                            placeholder="Name"
                            onChange={({ currentTarget }) => setCanName(currentTarget.value)}
                            value={canName}
                          />
                        </div>
                      </div> */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label
                            htmlFor="canEmail"
                            className="form-control-label"
                          >
                            Email
                          </label>
                          <input
                            type="text"
                            name="canEmail"
                            id="canEmail"
                            aria-label="Email Input"
                            className="form-control"
                            placeholder="Email"
                            onChange={({ currentTarget }) => setCanEmail(currentTarget.value)}
                            value={canEmail}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label
                            htmlFor="canEntity"
                            className="form-control-label"
                          >
                            Entity type
                          </label>
                          <select
                            name="canEntity"
                            id="canEntity"
                            className="form-control"
                            disabled={candidateType !== ""}
                            onChange={({ currentTarget }) => setCanEntityFunc(currentTarget)}
                            value={canEntity}
                          >
                            <option value="">Select</option>
                            {candidateEntity.map((item) => (
                              <option value={item.name}>{item.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label
                            htmlFor="canSubcontractor"
                            className="form-control-label"
                          >
                            Subcontractor
                          </label>
                          <select
                            name="canSubcontractor"
                            id="canSubcontractor"
                            className="form-control"
                            onChange={({ currentTarget }) => setCanSubcontractor(currentTarget.value)}
                            value={canSubcontractor}
                          >
                            <option value="">Select</option>
                            {filterSubcontractorList?.map((item) => (
                              <option value={item.fuid}>{item.label} - {item.fuid}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label
                            htmlFor="canRecruiter"
                            className="form-control-label"
                          >
                            Recruiter
                          </label>
                          <select
                            name="canRecruiter"
                            id="canRecruiter"
                            className="form-control"
                            onChange={({ currentTarget }) => setCanRecruiter(currentTarget.value)}
                            value={canRecruiter}
                          >
                            <option value="">Select</option>
                            {filterRecruiterList.map((item) => (
                              <option value={item.fuid}>{item.label} - {item.fuid}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label
                            htmlFor="canAgency"
                            className="form-control-label"
                          >
                            Agency
                          </label>
                          <select
                            name="canAgency"
                            id="canAgency"
                            className="form-control"
                            onChange={({ currentTarget }) => setCanAgency(currentTarget.value)}
                            value={canAgency}
                          >
                            <option value="">Select</option>
                            {filterAgencyList.map((item) => (
                              <option value={item.title}>{item.title}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12 text-center ">
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          onClick={() => handleCandidateFilter()}
                        >
                          <i className="fa fa-search mr-2" aria-hidden="true"></i>Search
                        </button>
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          onClick={()=>handleFilterCancel("refresh")}
                        >
                          <i className="fa fa-refresh mr-2" aria-hidden="true"></i>Refresh
                        </button>
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          //data-toggle="collapse"
                          //data-target="#collapseExample"
                          onClick={()=>handleFilterCancel("close")}
                        >
                          <i className="fa fa-close mr-2" aria-hidden="true"></i>Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
          <div className="card-body p-2">
            <Tabs
              activeKey={selectedTabKey}
              onSelect={(key) => setSelectedTabKey(key)}
              id="uncontrolled-tab-example"
              className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
            >
              <Tab eventKey="home" title="Candidates"
                tabClassName="page-tab border border-left-0 border-top-0">
                <Tab.Content className="border border-top-0">
                  <div className="table-responsive">
                    {/* <button className="btn btn-sm btn-link" onClick={handleResetSelection}>Reset Selection</button> */}
                    <table className="table align-items-center table-flush mb-2">
                      <thead className="thead-light">
                        <tr>
                          {type !== "timelog" && type !== "invoice" &&
                            <th className="pl-2 pr-3">Select
                              <br />
                              <span style={{ cursor: "pointer" }} onClick={handleResetSelection}>
                                <i className="fa fa-refresh ml-2 text-primary" aria-hidden="true"></i>
                              </span></th>
                          }
                          <th className={`${type !== "timelog" && type !== "invoice" && "pl-0 pr-0"}`}>
                            ID #
                            <br />IPCS ID
                          </th>
                          <th>Candidate</th>
                          <th>Entity Type</th>
                          {type === "timelog" || type === "invoice" ? <>
                            {type === "timelog" && (
                              <th>
                                Time Log
                                <br />
                                Management
                              </th>
                            )}
                            {type === "invoice" && (
                              <th>
                                Invoices and <br />
                                Payments
                              </th>
                            )}
                          </> : ""}

                              {/* <th>Onboarding Status</th> */}
                          {type !== "partner" && type !== "timelog" && type !== "invoice" && (
                            <>
                              <th>Agency/Client</th>
                              <th>Subcontractor</th>
                              <th>Recruiter</th>
                              <th>MSP</th>
                              <th>Tech/Other Fee</th>
                              <th>
                                Duration
                                <br />
                                Modify Rate
                              </th>
                            </>
                          )}
                          {type !== "timelog" && type !== "invoice" && type !== "application" && (
                            <th>Login Status</th>
                          )}

                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        {candidates.map((item, key) => (
                          <>
                            <tr className={`${(selectedKey !== key && selectedKey !== -1) || (SelectedFormKey !== key && SelectedFormKey !== -1) ? "d-none" : ""}`}>

                              {type !== "timelog" && type !== "invoice" &&
                                <td className="pb-0" >
                                  <div className="custom-control custom-radio">
                                    <input
                                      className="custom-control-input"
                                      type="radio"
                                      aria-label="Select Candidate"
                                      id={item.performerid}
                                      name="recruiter"
                                      onChange={() => handleSelectCandidate(item)}
                                      value={selectedCandidateId}
                                      checked={selectedCandidateId === item.performerid}
                                    />
                                    <label
                                      className="custom-control-label"
                                      aria-label="Select Candidate"

                                      htmlFor={item.performerid}
                                    >
                                    </label>
                                  </div>
                                </td>}

                              <td className={`${type !== "timelog" && type !== "invoice" && "pl-0 pr-0"}`}>
                                {item.performerid}
                                <br />
                                {item.maxloans}
                              </td>
                              <td className="pb-0">
                                <button
                                  onClick={() => handleViewcandidateForm("Candidate", key, item)}
                                  className="btn p-0 btn-link btn-sm text-uppercase">
                                  {item.performername} {item.lastName}
                                </button>
                                <br />
                                {item.performeremail}
                                <br />
                                {item.contactNo && getFormatedNumber(item.contactNo)}
                                <br />
                                <Moment format="MMM Do YYYY, h:mm a">
                                  {item.addedDateTime}
                                </Moment>
                              </td>

                              <td className="pb-0">
                                {getFieldData(
                                  item.performerData,
                                  "candidateonboardingform",
                                  "CandidateEntity"
                                ) === "1099 Basis" && "1099"}

                                {getFieldData(
                                  item.performerData,
                                  "candidateonboardingform",
                                  "CandidateEntity"
                                ) === "C2C Basis" && "C2C"}

                                {getFieldData(
                                  item.performerData,
                                  "candidateonboardingform",
                                  "CandidateEntity"
                                ) === "1099 Basis" &&
                                  type !== "partner" && (
                                    <>
                                      <br />
                                      Rate : {item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr"}
                                    </>
                                  )}
                                {getFieldData(
                                  item.performerData,
                                  "candidateonboardingform",
                                  "CandidateEntity"
                                ) === "W2 Basis" && (
                                    <>
                                      {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "w9_Type"
                                      )}
                                      {type !== "partner" && (
                                        <>
                                          <br />
                                          Rate : {item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr"}
                                          <br />
                                          {
                                            getFieldData(
                                              item.performerData,
                                              "candidateonboardingform",
                                              "Per_Diem_Rate"
                                            ) ? (
                                              <>
                                                Per Diem Rate :<RateEncryptDecrypt rateData={getFieldData(
                                                  item.performerData,
                                                  "candidateonboardingform",
                                                  "Per_Diem_Rate"
                                                )} endSymbol="/Day" />
                                              </>
                                            ) : ""
                                          }

                                        </>
                                      )}
                                    </>
                                  )}
                              </td>

                              {type === "timelog" || type === "invoice" ? <>
                                {(type === "timelog" || type === "invoice") && (
                                  <td className="pb-0">
                                    <button
                                      onClick={() => handleViewCandidateDetails(item, type)}
                                      className="btn btn-sm btn-link p-0"
                                    >
                                      Go
                                    </button>
                                  </td>
                                )}

                              </> :
                                ""}





                              {type !== "partner" && type !== "timelog" && type !== "invoice" && (
                                <React.Fragment>
                                  <td className="pb-0">
                                    <button
                                      className="btn btn-link btn-sm p-0"
                                      aria-label="View Agency Detail"
                                      onClick={() =>
                                        handleViewShowHide(item, "agency", key)
                                      }
                                    >

                                      {getFieldData(
                                        item.performerData,
                                        "projectengagement",
                                        "AgencyName"
                                      )}
                                    </button>

                                    <br />
                                    Rate : {item?.rates?.agencyRate ? <RateEncryptDecrypt rateData={item?.rates?.agencyRate} /> : "$0.00/Hr"}
                                    <br />
                                    {getAdminAgencyFee(item)}

                                  </td>
                                  <td className="pb-0">
                                    {getFieldData(
                                      item.performerData,
                                      "candidateonboardingform",
                                      "CandidateEntity"
                                    ) === "C2C Basis" ? (
                                      <React.Fragment>
                                        <div className="d-flex align-items-center gap-2">{
                                          item.subcontractor?.label &&
                                          <button
                                            className="btn btn-sm btn-link p-0 text-uppercase"
                                            onClick={() => handleViewcandidateForm("Subcontractor", key, item)}
                                          >
                                            {item.subcontractor?.label} ({item.subcontractor?.fuid}) {" "}
                                            {item.subcontractor.useFlag ?
                                              <i
                                                className="fa fa-check text-success"
                                                style={{ fontSize: "15px" }}
                                                aria-hidden="true"
                                              ></i> :
                                              <i
                                                className="fa fa-times text-danger"
                                                style={{ fontSize: "15px" }}
                                                aria-hidden="true"
                                              ></i>}
                                          </button>
                                        }

                                        </div>
                                        Rate : {item?.rates?.subcontractorRate ? <RateEncryptDecrypt rateData={item?.rates?.subcontractorRate} /> : "$0.00/Hr"}
                                        <br />
                                        {item.subcontractor !== null &&
                                          item.subcontractor.email}
                                        <br />
                                        {item?.subcontractor && (
                                          <Moment format="MMM Do YYYY, h:mm a">
                                            {item.subcontractor.createdDate}
                                          </Moment>
                                        )}

                                      </React.Fragment>
                                    ) : (
                                      "NA"
                                    )}
                                    <br />

                                  </td>
                                  <td className="pb-0">
                                    {item.recruiter !== null ? (
                                      <React.Fragment>
                                        <div className="d-flex align-items-center gap-2">
                                          <button
                                            className="btn btn-sm btn-link p-0 text-uppercase"
                                            onClick={() => handleViewcandidateForm("Recruiter", key, item)}
                                          >
                                            {item.recruiter?.label} ({item.recruiter?.fuid}) {" "}
                                            {item.recruiter.useFlag ?
                                              <i
                                                className="fa fa-check text-success"
                                                style={{ fontSize: "15px" }}
                                                aria-hidden="true"
                                              ></i> :
                                              <i
                                                className="fa fa-times text-danger"
                                                style={{ fontSize: "15px" }}
                                                aria-hidden="true"
                                              ></i>}
                                          </button>
                                        </div>
                                        Rate : {item?.rates?.recruiterRate ? <RateEncryptDecrypt rateData={item?.rates?.recruiterRate} /> : "$0.00/Hr"}
                                        <br />
                                        {item.recruiter.email}
                                        <br />
                                        <Moment format="MMM Do YYYY, h:mm a">
                                          {item.recruiter.createdDate}
                                        </Moment>

                                      </React.Fragment>
                                    ) : (
                                      "NA"
                                    )}

                                  </td>

                                  <td className="pb-0">
                                    {getFieldData(
                                      item.performerData,
                                      "candidateonboardingform",
                                      "Msp_Mode"
                                    ) !== "" && (
                                        <>
                                          <button
                                            className="btn btn-sm btn-link p-0"
                                            onClick={() =>
                                              handleViewShowHide(item, "msp", key)
                                            }
                                          >
                                            {getFieldData(
                                              item.performerData,
                                              "candidateonboardingform",
                                              "Msp_Mode"
                                            ) === "Others" ?
                                              getFieldData(
                                                item.performerData,
                                                "candidateonboardingform",
                                                "MSP_Other_Mode"
                                              ) :
                                              getFieldData(
                                                item.performerData,
                                                "candidateonboardingform",
                                                "Msp_Mode"
                                              )}
                                          </button>
                                          <br />
                                          Admin Fee : <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Msp_AdminFee")} startSymbol="" endSymbol="%" />
                                        </>
                                      )}
                                  </td>
                                  <td className="pb-0">
                                     Candidate : {item?.rates?.candidateTechFee ? <RateEncryptDecrypt rateData={item?.rates?.candidateTechFee} /> : "$0.00/Hr"}
                                    <br />
                                    Subcontractor : {item?.rates?.subcontractorTechFee ? <RateEncryptDecrypt rateData={item?.rates?.subcontractorTechFee} /> : "$0.00/Hr"}
                                    <br />
                                    Recruiter : {item?.rates?.recruiterTechFee ? <RateEncryptDecrypt rateData={item?.rates?.recruiterTechFee} /> : "$0.00/Hr"}
                                    <p className="mt-1"> Hub Fee : {getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee") ?
                                      <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee")} startSymbol="" endSymbol="%" /> : "%"}</p>
                                  </td>
                                  <td className="pb-0">
                                    {item.duration !== null && (
                                      <React.Fragment>
                                        {item.duration.duration} Months
                                        <br />
                                        Start : <Moment format="MMM Do YYYY">
                                          {item.duration.startDate}
                                        </Moment>
                                        <br />
                                        End : <Moment format="MMM Do YYYY">
                                          {item.duration.endDate}
                                        </Moment>
                                      </React.Fragment>
                                    )}
                                    <br />
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        handleDurationAndRateShowHide(
                                          item,
                                          "duration", key
                                        )
                                      }
                                    >
                                      Edit Duration
                                    </button>
                                    <br/>
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        handleDurationAndRateShowHide(item, "rate", key)
                                      }
                                    >
                                      Modify Rate
                                    </button>
                                    {checkTerminateDuration(item, key)}
                                  </td>

                                </React.Fragment>
                              )}
                              {type !== "timelog" && type !== "invoice" && type !== "application" && (
                                <>
                                  <td className="pb-0">
                                    {item.isActive === null && (
                                      <Spinner animation="border" role="status">
                                        <i className="fa fa-spinner fa-spin fa-2x fa-fw mb-2"></i>
                                      </Spinner>
                                    )}
                                    <React.Fragment>
                                      {item.isActive === true && (
                                        <>
                                          <i
                                            className="fa fa-check text-success"
                                            style={{ fontSize: "15px" }}
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Activated
                                          {item.isActiveDateTime && (
                                            <>
                                              <br />
                                              <Moment format="MMM Do YYYY, h:mm a">
                                               {item.isActiveDateTime}
                                              </Moment>
                                              
                                            </>
                                          )}
                                          <br />
                                        </>
                                      )}
                                      {item.isActive === false && (
                                        <>
                                          <i
                                            className="fa fa-times text-danger"
                                            style={{ fontSize: "15px" }}
                                            aria-hidden="true"
                                          ></i>{" "}
                                          Deactivated
                                          {item.isActiveDateTime && (
                                            <>
                                              <br />
                                               <Moment format="MMM Do YYYY, h:mm a">
                                                {item.isActiveDateTime}
                                              </Moment>
                                            </>
                                          )}
                                          <br />
                                        </>
                                      )}
                                      {item.isActive === null ? (
                                        <>
                                          To Activate
                                          {item.isActiveDateTime && (
                                            <>
                                              <br />
                                              <Moment format="MMM Do YYYY, h:mm a">
                                                {item.isActiveDateTime}
                                              </Moment>
                                            </>
                                          )}
                                        </>
                                      ) : <button
                                        className="btn btn-sm btn-link p-0"
                                        onClick={() =>
                                          handleRemainder(
                                            item.performerid
                                          )
                                        }
                                      >
                                        Resend
                                      </button>}
                                    </React.Fragment>
                                  </td>

                                </>
                              )}

                            </tr>
                            {type !== "timelog" && type !== "invoice" && (
                              <>
                                {item.applications
                                  .filter((x) => x.processType === 1)
                                  .map((app) => (
                                    <tr className={`${(selectedKey !== key && selectedKey !== -1) || (SelectedFormKey !== key && SelectedFormKey !== -1) ? "d-none" : ""}`}>
                                      {type !== "partner" && (
                                        <>
                                          <td colSpan={2} className="border-0 pt-0 pb-1"></td>
                                          <td colSpan={2} className="border-0 pt-0 pb-1" >

                                            <>
                                              {type === "application" &&
                                                <>
                                                  <button
                                                    onClick={() => handleDocumentViewShowHide("Candidate", key, app, item)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                  >
                                                    Send Contract Documents
                                                  </button>

                                               
                                                </>
                                              }
                                              {type === "application" && getFieldData(
                                                item.performerData,
                                                "candidateonboardingform",
                                                "CandidateEntity"
                                              ) !== "C2C Basis" && <>
                                              <br/>
                                                  <button
                                                    onClick={() => handleACHShowHide("ACH", "Candidate", item, key, app)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                  >
                                                    ACH Information <span className="badge badge-pill badge-danger">{app?.achRequest}</span>
                                                  </button>
                                                  {/* <br />
                                                  <button
                                                    onClick={() => handleInsuranceShowHide("Insurance", "Candidate", item, key, app)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                  >
                                                    Insurance Information
                                                  </button> */}
                                                </>}
                                            </>

                                          </td>
                                          <td className="border-0 pt-0">
                                            {
                                              getFieldData(
                                                item.performerData,
                                                "projectengagement",
                                                "AgencyName"
                                              ) &&
                                              <button
                                                onClick={() => handleDocumentViewShowHide("agency", key, app, item)}
                                                className="btn btn-sm btn-link p-0"
                                                title="Contract Documents"
                                              >
                                                Upload Document
                                              </button>
                                            }

                                          </td>
                                          <td className="border-0 pt-0">
                                            {getFieldData(
                                              item.performerData,
                                              "candidateonboardingform",
                                              "CandidateEntity"
                                            ) === "C2C Basis" ? (
                                              item.subcontractor?.fuid && (
                                                <button
                                                  onClick={() => handleDocumentViewShowHide("Subcontractor", key, app, item)}
                                                  className="btn btn-sm btn-link p-0"
                                                  title="Documents"
                                                >
                                                  Send Documents
                                                </button>
                                              )
                                            ) : ("")}
                                            <>
                                              {type === "application" && item?.subcontractor?.fuid > 0 &&
                                                <>
                                                  <div className="d-flex flex-column align-items-start">
                                                    {/* <button
                                                      onClick={() => handleACHShowHide("ACH", "Subcontractor", item, key, app)}
                                                      className="btn btn-sm btn-link p-0"
                                                      title="Contract Documents"
                                                    >
                                                      ACH Information
                                                    </button>
                                                    <button
                                                      onClick={() => handleInsuranceShowHide("Insurance", "Subcontractor", item, key, app)}
                                                      className="btn btn-sm btn-link p-0"
                                                      title="Contract Documents"
                                                    >
                                                      Insurance Information
                                                    </button>
                                                    <button
                                                      className="btn btn-sm btn-link p-0 text-left"
                                                      onClick={() => handlePurchaseShowHide(item, "add", "Subcontractor")}
                                                    >
                                                      Send Purchase Order
                                                    </button>  */}
                                                  </div>
                                                </>
                                              }
                                            </>
                                          </td>
                                          <td className="border-0 pt-0">
                                            {item.recruiter !== null ? (
                                              <button
                                                onClick={() => handleDocumentViewShowHide("Recruiter", key, app, item)}
                                                className="btn btn-sm btn-link p-0"
                                                title="Documents"
                                              >
                                                Send Documents
                                              </button>) : ("")}

                                                <>
                                              {type === "application" && item.recruiter?.fuid > 0 &&
                                                <div className="d-flex flex-column align-items-start">
                                                  {/* <button
                                                    onClick={() => handleACHShowHide("ACH", "Recruiter", item, key, app)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                  >
                                                    ACH Information
                                                  </button>
                                                  <button
                                                    onClick={() => handleInsuranceShowHide("Insurance", "Recruiter", item, key, app)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                  >
                                                    Insurance Information
                                                  </button> 
                                                  <button
                                                    className="btn btn-sm btn-link p-0 text-left"
                                                    onClick={() => handlePurchaseShowHide(item, "add", "Recruiter")}
                                                  >
                                                    Send Purchase Order
                                                  </button> */}
                                                </div>
                                              }
                                            </>
                                          </td>
                                          <td className="border-0 pt-0">
                                            {getFieldData(
                                              item.performerData,
                                              "candidateonboardingform",
                                              "Msp_Mode"
                                            ) !== "" && (
                                                <button
                                                  onClick={() => handleDocumentViewShowHide("msp", key, app)}
                                                  className="btn btn-sm btn-link p-0"
                                                  title="Contract Documents"
                                                >
                                                  Upload Document
                                                </button>)}
                                          </td>
                                          <td colSpan={4} className="border-0 pt-0"></td></>)}
                                    </tr>
                                  ))}
                                {item.applications
                                  .filter((x) => x.processType === 1)
                                  .map((app) => (
                                    <tr className={`${(selectedKey !== key && selectedKey !== -1) || (SelectedFormKey !== key && SelectedFormKey !== -1) ? "d-none" : ""}`}>
                                      {type !== "partner" && (
                                        <>
                                          <td colSpan={2} className="border-0 pt-0 pb-1"></td>
                                          <td colSpan={1} className="border-0 pt-0 pb-1" >
                                            <>
                                              {type === "application" && getFieldData(
                                                item.performerData,
                                                "candidateonboardingform",
                                                "CandidateEntity"
                                              ) === "W2 Basis" &&
                                                <>
                                                  <div className="d-flex flex-column align-items-start">
                                                    <button
                                                      className="btn btn-sm btn-link p-0"
                                                      title="Coming Soon....."
                                                    >
                                                      I9 Verification
                                                    </button>
                                                  </div>
                                                </>
                                              }

                                              <div key={app.applicationId} className="mb-2 text-left">
                                                {/* <span>
                                                          {app.applicationType} ({app.applicationId})
                                                        </span> */}
                                                <div className="mt-1">
                                                  {type === "application" ? (
                                                    app.appSubmitted ? (
                                                      <button
                                                        onClick={() => handleViewApplication(item, app)}
                                                        className="badge badge-success rounded-0 btn-min-width cursor-pointer"
                                                        style={{ border: "none" }}
                                                      >
                                                        Complete ({app.applicationId})
                                                      </button>
                                                    ) : (
                                                      <button
                                                        onClick={() => handleViewApplication(item, app)}
                                                        className="badge badge-success rounded-0 bg-yellow btn-min-width cursor-pointer"
                                                        style={{ border: "none" }}
                                                      >
                                                        Review ({app.applicationId})
                                                      </button>
                                                    )
                                                  ) : app.appSubmitted ? (
                                                    <button className="badge badge-success rounded-0 btn-min-width" style={{ border: "none" }}>
                                                      Complete ({app.applicationId})
                                                    </button>
                                                  ) : (
                                                    <button className="badge badge-success rounded-0 bg-yellow btn-min-width" style={{ border: "none" }}>
                                                      Review ({app.applicationId})
                                                    </button>
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          </td>
                                          <td colSpan={2} className="border-0 pt-0 pb-1"></td>
                                          <td colSpan={1} className="border-0 pt-0 pb-1" >
                                            
                                          </td>
                                          <td colSpan={1} className="border-0 pt-0 pb-1">
                                          </td>
                                          <td colSpan={4} className="border-0 pt-0 pb-1"></td>
                                        </>
                                      )}
                                    </tr>
                                  ))}
                              </>
                            )}
                            <tr className={`${selectedKey === key || SelectedFormKey === key ? "" : "d-none"}`}>
                              {viewShowHide && editDurType === "" && selectedKey === key &&
                                <td colSpan={13} className="bg-white" style={{ width: "100%" }}>
                                  <ViewCandidate
                                    handleDurationShowHide={handleDurationAndRateShowHide}
                                    heading={""}
                                    viewShowHide={viewShowHide}
                                    handleViewShowHide={handleViewShowHide}
                                    selectedObj={selectedObj}
                                    viewType={viewType}
                                    filterSubcontractorList={filterSubcontractorList}
                                    filterRecruiterList={filterRecruiterList}
                                  ></ViewCandidate>
                                </td>
                              }
                              {wfForm && SelectedFormKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="d-flex justify-content-between align-items-center mb-3 pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => handleCloseViewForm(`${viewFormType}`, -1, null)}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                    <h2 className="m-0 text-center text-capitalize ms-3">{viewFormType} Details</h2>
                                    <div></div>
                                  </div>
                                  <WorkflowElement
                                    wfTask={wfTask}
                                    wfForm={wfForm}
                                    handleNextTask={handleNextTask}
                                    viewType={true}
                                    appSummary={false}
                                    codeVerified={true}
                                    wfTaskType={"form"}
                                    // actionType={"workflow"}
                                    updatedStateData={updatedStateData}
                                  />
                                </td>}
                              {editDurType === "duration" && selectedKey === key && <td colSpan={13} className="bg-white" style={{ width: "100%" }}>
                                <AddEditDuration
                                  handleDurationShowHide={handleDurationAndRateShowHide}
                                  selectedObj={selectedObj}
                                  editType={editDurType}
                                ></AddEditDuration>
                              </td>}
                              {editDurType === "rate" && selectedKey === key && <td colSpan={13} className="bg-white" style={{ width: "100%" }}>
                                <AddEditRates
                                  handleDurationShowHide={handleDurationAndRateShowHide}
                                  selectedObj={selectedObj}
                                  editType={editDurType}
                                ></AddEditRates>
                              </td>}
                              {editDurType && selectedKey === key && fetchedDataType === "Document" && !viewShowHide &&
                                <td colSpan={9} className="bg-white p-3">
                                  <div className="text-left mb-0 pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => handleCloseDocumentView(`${editDurType}`, -1, null)}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4">
                                    <h3>{editDurType === "msp" ? "MSP DOCUMENTS" : `${editDurType.toUpperCase()} DOCUMENTS`} </h3>
                                  </div>
                                  <Document
                                    documents={appDocuments}
                                    workflowTask={selectedCurrentTask}
                                    uploadType={`${editDurType}`}
                                    app={selectedApp}
                                    item={item}
                                    recieveStatus={false}
                                    viewType={(editDurType === "Subcontractor" || editDurType === "Recruiter") ? "candidateList" : ""}
                                    candidateObj={candidateObj}
                                    handleCloseDocumentView={handleCloseDocumentView}
                                  />
                                </td>}
                              {selectedInfo === "ACH" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{achType} ACH Information</h3></div>
                                  <AchInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"candidateList1"}
                                    achType={achType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}
                              {selectedInfo === "Insurance" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{insuranceType} Insurance Information</h3></div>
                                  <InsuranseInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"candidateList1"}
                                    insuranceType={insuranceType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}

                            </tr >
                          </>
                        ))}
                      </tbody >
                    </table >
                  </div >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {dataType === 'filter' && candidates.length === 0 && (
                      canEntity === 'C2C Basis' ?
                        <span className="text-red">No Result Found in C2C</span> : canEntity === '1099 Basis' ?
                          <span className="text-red">No Result Found in 1099 Basis</span> : canEntity === 'W2 Basis' ?
                            <span className="text-red">No Result Found in W2 Basis</span> :
                            <span className="text-red">No Result Found</span>
                    )}
                  </div>
                  {selectedKey === -1 && SelectedFormKey === -1 &&
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    />
                  }

                </Tab.Content >
              </Tab >
              {type === "application" &&
                <Tab eventKey="addEditCandidate" title={`${selectedCandidateId === 0 ? "Add" : "Edit"} Candidate & Entities`}
                  tabClassName="page-tab border border-left-0 border-right-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedTabKey === "addEditCandidate" &&
                      <AddCandidate
                        selectedObj={selectedObj}
                        setSelectedTabKey={setSelectedTabKey}
                        setSelectedCandidateId={setSelectedCandidateId}
                        selectedTabKey={selectedTabKey}
                        actType={selectedCandidateId === 0 ? "add" : "edit"}
                        handleAddEditCandidate={handleAddEditCandidate}
                        handleGoBack={handleGoBackCan}
                      />}
                  </Tab.Content>
                </Tab>
              }
              {
                type === "partner" &&
                <Tab eventKey="status" title="Activate/Deactivate" tabClassName="page-tab border border-left-0 border-right-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedCandidateId === 0 && <div className="">
                      <h2 className="text-danger mt-1"> Alert : Please select the Candidate first</h2>
                    </div>}

                    {selectedCandidateId > 0 &&
                      <ActiveDeactiveHistory selectedObj={selectedObj} type="performer" typeName="Candidate" actionType={actionType} handlePermissionShowHide2={handlePermissionShowHide2} />}
                  </Tab.Content>
                </Tab>
              }

            </Tabs >
          </div >
        </div >
      </div >
      {
        candidates.length > 0 &&
        <React.Fragment>

          {remainderMsgShowHide &&
            <ReminderAlertMessage
              remainderMsgShowHide={remainderMsgShowHide}
              handleRemainderMessage={handleRemainderMessage}
            ></ReminderAlertMessage>
          }
        </React.Fragment>
      }

      {purchaseShowHide && <PurchaseOrderPopup
        purchaseShowHide={purchaseShowHide}
        handlePurchaseShowHide={handlePurchaseShowHide}
        candidateObj={candidateObj}
        workflowTask={selectedCurrentTask}
        poOrderType={poOrderType}
        item={selectedItem}
        handleSignUnsignPo={handleSignUnsignPo}
        handleRefreshPoOrders={handleRefreshPoOrders}
      ></PurchaseOrderPopup>}
    </React.Fragment >
  );
}

